export default {
  minGold: 100,
  maxGold: 1000,
  rewards: {
    min: 100,
    max: 50000
  }
};
